<div class="d-flex justify-content-center align-items-stretch h-100">
	@if (showLoadingSpinner) {
		<button disabled type="button" [class]="innerClass + ' w-100 d-flex justify-content-center px-0 py-1'">
			<app-loading-spinner size="40px" fillColor="white"></app-loading-spinner>
		</button>
	} @else {
		<button
			type="button"
			[class]="innerClass + ' w-100 d-flex justify-content-center px-0'"
			(click)="clicked.emit()">
			<app-icon [name]="iconName" [color]="iconColor"></app-icon>
			{{ label }}
		</button>
	}
</div>
